const queryKeys = {
  all: (partyId: string) => ['documents', partyId] as const,

  lists: (partyId: string) => [...queryKeys.all(partyId), 'lists'] as const,
  details: (partyId: string) => [...queryKeys.all(partyId), 'details'] as const,

  list: (partyId: string, filter: unknown) =>
    [...queryKeys.lists(partyId), filter] as const,
  byId: (id: string) => [...queryKeys.details(''), id] as const,
};

export default queryKeys;
